import React, { Component } from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";
import { Query } from "react-apollo";
import Box from "grommet/components/Box";
import Button from "grommet/components/Button";
import Header from "grommet/components/Header";
import Anchor from "grommet/components/Anchor";
import AppSettings from "../../utils/appSettings";
import MenuIcon from "grommet/components/icons/base/Menu";
import IconAdd from "grommet/components/icons/base/Add";
import Title from "grommet/components/Title";
import { DefaultLoader } from "../../components/common/DefaultLoader";
import { withSnackbar } from "../../components/snackbar";
import MapRequestList from "../../components/easyScaleMap/viewer/MapRequestList";
import { EasyTippy } from "../../components/common/Tooltip";
import { push } from "connected-react-router";
import { withTour } from "../../onboarding";
import tour from "./EasyScaleMap.tour"
export const MAP_REQUEST_PER_PAGE = 20;


export const GET_MAP_REQUESTS = gql`
  query myOrganisationMapRequests($after: String, $itemsPerPage: Int) {
    myOrganisationMapRequests(after: $after, itemsPerPage: $itemsPerPage) {
      id
      case {
        id
        name
      }
      name
      createdAt
      updatedAt
      status
      progress
      errorMessage
    }
  }
`;

class EasyScaleMap extends Component {
  _renderContent() {
    const { push, mapRequestRefreshLength } = this.props
    return (
      <Query query={GET_MAP_REQUESTS} variables={{
        itemsPerPage: mapRequestRefreshLength ? mapRequestRefreshLength : MAP_REQUEST_PER_PAGE,
      }} pollInterval={AppSettings.defaultPollingTime / 4 } fetchPolicy={"cache-and-network"}>
        {({ loading, error, data, fetchMore }) => {
          if (loading && !data.myOrganisationMapRequests )
            return (
              <Box full align="center" justify="center">
                <DefaultLoader />
              </Box>
            );
          if (error) {
            console.error(error);
            return <div>{error.toString()}</div>;
          }
          let { myOrganisationMapRequests } = data;
          return (
            <Box align="center">
              <MapRequestList
                mapRequests={myOrganisationMapRequests}
                onStartWizard={() => push('/app/map/new')}
                fetchMore={fetchMore}
              />
            </Box>
          );
        }}
      </Query>
    );
  }

  _renderHeader() {
    const {push} = this.props
    let appLogo;
    let mobileButton;
    let title = (
      <Title pad="small" responsive={true}>
        Cartes
      </Title>
    );
    let colorIndex = "light-1";
    let justify = "between";
    if ("single" === this.props.responsive) {
      justify = "end";
      appLogo = this.props.renderAppLogo();
      colorIndex = AppSettings.mainColor;
      mobileButton = <Anchor icon={<MenuIcon />} onClick={this.props.onMenuOpen} />;
    }
    return (
      <Header size="small" colorIndex={colorIndex} className="drop-shadow-bottom" fixed={true}>
        {appLogo}
        <Box flex={true} justify={justify} align="center" pad="small" direction="row" responsive={false}>
          <Box direction="row" align="center">
            {title}
          </Box>
            <Box margin={{ horizontal: "small" }} direction="row" responsive={false} align="center">

                <EasyTippy text="Lancer une recherche">
                  <Button
                    icon={<IconAdd />}
                    id="createMapRequest"
                    onClick={() =>
                      push('/app/map/new')
                    }
                  />
                </EasyTippy>
            </Box>

          {mobileButton}
        </Box>
      </Header>
    );
  }

  render() {
    return (
      <Box full="vertical" colorIndex={AppSettings.backgroundColor}>
        {this._renderHeader()}
        {this._renderContent()}
      </Box>
    );
  }
}

const mapStateToProps = state => {
  return {
    mapRequestRefreshLength: state.mapRequest.mapRequestRefreshLength
  };
};
const mapDispatchToProps = dispatch => {
  return {
    push: url => {
      dispatch(push(url));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
// )(withSnackbar()(withTour(tour)(EasyScaleMap)));
)(withSnackbar()(EasyScaleMap));
